export const ensureNever = (value: never): never => {
    throw new Error(`expected never to be called, got ${value}`);
};

export const ensureDefined = <T>(value: T | undefined | null, message = "must be defined"): T => {
    if (value === null || typeof value === "undefined") {
        throw new Error(message);
    }
    return value;
};
